import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { inputDataPicker } from 'components/InitialStyle';

type ComponentTypes = {
  name?: any;
  error?: any;
  control?: any;
  label?: string;
  required?: boolean;
};

const CustomTimePicker = ({
  name,
  error,
  control,
  label = '',
  required = true,
}: ComponentTypes) => {
  return (
    <Box width='100%' position='relative'>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>
      <div style={{ marginTop: '5px' }}></div>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required,
        }}
        render={({ field }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              sx={{
                paddingTop: '0 !important',
                overflow: 'hidden',
              }}
              components={['TimePicker']}>
              <TimePicker
                ampm={false}
                sx={{
                  ...inputDataPicker(Boolean(error?.[name]?.type)),
                  '.MuiInputBase-root': {
                    width: '110px',
                    height: '40px',
                    overflow: 'hidden',
                  },
                  '.MuiInputBase-input': {
                    width: '80px',
                  },
                }}
                value={field.value !== undefined ? dayjs(new Date(field.value)) : null}
                onChange={(e: any) => field.onChange(e)}
              />
            </DemoContainer>
          </LocalizationProvider>
        )}
      />
      <ErrorMessage error={error} name={name} />
    </Box>
  );
};

export default CustomTimePicker;
